export const PRIMARY_CONTACT_NAME_SORT_COLUMN = `contactPrimaryContactName`;
//# sourceMappingURL=invoice.js.map